import { render, staticRenderFns } from "./head.vue?vue&type=template&id=0a1c0de2&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=0a1c0de2&prod&lang=less"
import style1 from "./head.vue?vue&type=style&index=1&id=0a1c0de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c0de2",
  null
  
)

export default component.exports